import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBalance } from '../../selectors/user';
import { BalanceMobile } from './BalanceMobile';

export const BalanceMobileContainer = () => {
  const balance = useSelector(selectBalance);

  return <BalanceMobile balance={balance} />;
};
